import {Link, useLocation, useNavigate} from "react-router-dom";
import {useEffect, useState} from "react";
import {NikeApp} from "@nike/nike-design-system-icons";
import {NavItem, setActiveValueInNavItems, VerticalNavbar} from "@nike/eds";
import { Avatar } from "@nike/eds";
import { useOktaAuth } from '@okta/okta-react'
import { useMemo } from 'react'

export function UserAvatar() {
    const { authState } = useOktaAuth()
    const initials = useMemo(() => {
        const name = authState?.accessToken?.claims?.sub
        return name ? getInitials(name) : '-'
    }, [authState])

    return (
        <Avatar initials={initials} size={36} />
    )
}

function getInitials(name: string) {
    const matchedFirstLetters = name.match(/(\b[A-Z])/g)
    if (!matchedFirstLetters || matchedFirstLetters.length < 2) {
        // Fallback: take first letter
        return name[0]?.toUpperCase()
    }
    return `${matchedFirstLetters.shift()}${matchedFirstLetters.pop()}`
}

export function SideBar() {
    const navigate = useNavigate()
    const location = useLocation()
    const routingMap = new Map<string, string>([
        ["1",  '/dashboard'],
        ["4", '/flow-overview'],
        ["5", '/master-data'],
        ["2", '/exceptions'],
        ["3", '/equipment-vehicles']
    ]);
    const [items, setItems] = useState<NavItem[]>([
        {
            id: '1',
            icon: 'GridView',
            label: 'Dashboard',
            active: false,
        },
        {
            id: "2",
            icon: 'AlertCircle',
            label: "Exceptions",
            active: false,
        },
        {
            id: "3",
            icon: 'Shipping',
            label: "Equipment Vehicles",
            active: false,
        },
        {
            id: "4",
            icon: "Feed",
            label: "Analytics",
            active: false,
        },
        {
            id: "5",
            icon: 'Data',
            label: "Master Data",
            active: false,
        },
            
        

    ])

    const handleClick = (item: { id: string }) => {
        navigate(routingMap.get(item.id)!)
    }

    useEffect(() => {

    }, [])

    useEffect(() => {
            changeIconBasedOnLocation()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location])

    const setActiveIcon = (id: string) => {
        const newItems = setActiveValueInNavItems(id, items)
        if (newItems) { setItems(newItems as NavItem[]) }
    }

    function changeIconBasedOnLocation() {
        setItems((prevItems) =>
            prevItems.map((item) => {
                const route = routingMap.get(item.id);
                const isActive = !!(route && location.pathname.includes(route)); // always boolean

                // Check subItems
                let subItems = item.subItems;
                if (subItems) {
                    subItems = subItems.map((subItem) => {
                        const subRoute = routingMap.get(subItem.id);
                        return {
                            ...subItem,
                            active: !!(subRoute && location.pathname.includes(subRoute)), // always boolean
                        };
                    });
                    // If any subItem is active, parent should be active too
                    if (subItems.some((sub) => sub.active)) {
                        return { ...item, active: true, subItems };
                    }
                }

                return { ...item, active: isActive, subItems };
            })
        );
    }

    return (

        <VerticalNavbar
            appName={'Customs Compliance Hub'}
            items={items}
            navLogoSlot={
                <Link reloadDocument to='/' aria-label='logo-link'>

                    <NikeApp
                        title='Nike logo'
                        color={'white'}
                        width={'56px'}
                        height={'64px'}
                        style={{marginTop: '6px'}}
                    />
                </Link>
            }
            onNavigate={handleClick}
        />
    )

}
